export default class ID {
  static name = 'ID'

  static parse (value) {
    if (_.isString(value)) {
      return Number.parseInt(value)
    } else {
      return value
    }
  }
}
